import RuleModel from '@/common/models/rules/rule-model';
import addRoute from '@/router/add-route';

const RulesEngine = () => import('@/modules/rules-engine/rules-engine');
const SystemEvents = () => import('@/modules/rules-engine/system-events');
const Lists = () => import('@/modules/rules-engine/lists/lists');
const ListForm = () => import('@/modules/rules-engine/lists/list-form');
const ListHistory = () => import('@/modules/rules-engine/lists/list-history');
const EventRules = () => import('@/modules/rules-engine/event-rules');
const EventHistory = () => import('@/modules/rules-engine/rule-history');
const RuleForm = () => import('@/modules/rules-engine/rule-form');

const rules = [
    addRoute({
        name: 'rules-engine',
        path: '/rules/',
        component: RulesEngine,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'system-events',
        path: '/rules/system',
        component: SystemEvents,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'value-lists',
        path: '/rules/lists',
        component: Lists,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-list-item',
        path: '/rules/lists/add',
        component: ListForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'edit-list-item',
        path: '/rules/lists/:id/:continue?',
        component: ListForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'history-list-item',
        path: '/rules/lists/:id/history/:version',
        component: ListHistory,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'view-system-event',
        path: '/rules/events/:eventType/:view?',
        component: EventRules,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'view-system-event-history',
        path: '/rules/events/:eventType/history/:version',
        component: EventHistory,
        root: {label: 'Automations', name: 'automations'},
    }),
    // system events add/edit
    addRoute({
        name: 'add-system-rule',
        path: '/rules/events/:eventType/rule/add',
        component: RuleForm,
        root: {label: 'Automations', name: 'automations'},
        meta: {
            itemType: RuleModel.Types.rule.family,
        },
    }),
    addRoute({
        name: 'add-system-bind',
        path: '/rules/events/:eventType/bind/add',
        component: RuleForm,
        root: {label: 'Automations', name: 'automations'},
        meta: {
            itemType: RuleModel.Types.bind.family,
        },
    }),
    addRoute({
        name: 'edit-system-rule',
        path: '/rules/events/:eventType/rule/:itemIndex',
        component: RuleForm,
        root: {label: 'Automations', name: 'automations'},
        meta: {
            itemType: RuleModel.Types.rule.family,
        },
    }),
    addRoute({
        name: 'edit-system-bind',
        path: '/rules/events/:eventType/bind/:itemIndex',
        component: RuleForm,
        root: {label: 'Automations', name: 'automations'},
        meta: {
            itemType: RuleModel.Types.bind.family,
        },
    }),
];

export default rules;
